module.exports = __webpack_public_path__ + "img/keyboard-arrow-down.89eacfd5.svg";